import React from 'react';
import { FormattedMessage } from 'react-intl';
import { format } from '../../lib/money';
import '../../css/share-details.css';

const EstimatedPayment = ({ title, amount }) => (
  <div className="share-details pl-2 py-1 sapphire-blue">
    <h4>{ title }</h4>
    <div><b>{format(amount)}</b></div>
  </div>
);

EstimatedPayment.defaultProps = {
  title: <FormattedMessage
    id="EstimatedPayment.title"
    defaultMessage="Estimated first payment"
  />,
  amount: {
    amountCents: 0,
    currencyCode: 'USD',
  },
};

export default EstimatedPayment;



// WEBPACK FOOTER //
// ./src/desktop/components/commit-form/estimated-payment.js